import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({ name: 'TixTabs' })
export default class default_1 extends Vue {
    @Prop({ required: true })
    tabs;
    @Prop({ default: null })
    value;
}
